import { render, staticRenderFns } from "./ScreeningTasks.vue?vue&type=template&id=c1952660&"
import script from "./ScreeningTasks.vue?vue&type=script&lang=js&"
export * from "./ScreeningTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports